var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRiskLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11116_2672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9973 7.42079C14.072 8.63753 14.6658 10.2046 14.6673 11.828L12.261 11.8302C12.2601 10.7928 11.8806 9.79132 11.1938 9.01376L12.9973 7.42079Z",
    fill: "#B9C2C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 11.8341C1.33398 10.2107 1.92634 8.64313 2.99991 7.4254L4.80489 9.0167C4.11882 9.7949 3.74027 10.7967 3.74027 11.8341H1.33398Z",
    fill: "#05B681"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55167 6.86916C4.7607 5.7858 6.32348 5.18081 7.94682 5.1677C9.57017 5.15459 11.1425 5.73427 12.3689 6.79797L10.7922 8.61574C10.0085 7.93597 9.00366 7.56553 7.96625 7.5739C6.92884 7.58228 5.93013 7.9689 5.1575 8.66124L3.55167 6.86916Z",
    fill: "#B9C2C0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 11.5007,
    r: 1,
    fill: "#02B37F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50024 10.0007L7.50015 12.001L8.00017 11.0009L4.50024 10.0007Z",
    fill: "#02B37F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11116_2672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.500732)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskLow);
export default __webpack_public_path__ + "static/media/risk-low.8c11dfc9d3fd9985bb7532abc194796f.svg";
export { ForwardRef as ReactComponent };